import React, { useEffect, useState, useMemo } from "react";
import {
    sendAPIRequest,
    generateOptionsFromData,
    displayNotification,
} from "../../../helpers";
import DataTable from "../../components/DataTable";
import { GridActionsCellItem } from "@mui/x-data-grid"
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { LinearProgress, Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import AutoCompleteDropdown from "components/autocomplete/AutoCompleteDropdown";
import Tooltip from "@mui/material/Tooltip";


const Index = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [translatedData, settranslatedData] = useState([]);
    const [languages, setlanguages] = useState([]);
    const [activeCountryId, setActiveCountryId] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState({ label: "", value: "" });
    const [selectedContentType, setSelectedContentType] = useState("");
    const [progress, setProgress] = useState(0);
    const [country, setCountry] = useState([]);
    const { t } = useTranslation();
    const authData = useSelector(s => s.auth.data);

    // const languageOptions = [{ label: "English", value: 3 }, { label: "French", value: 4 }, { label: "Spanish", value: 5 }]
    const ContentTypeOptions = [{ label: "Headings", value: "Headings" }, { label: "Concepts", value: "Concepts" }, { label: "Umberalla Concepts", value: "Umberalla-Concepts" }]
    useEffect(() => {
        const calculateProgress = () => {

            if (data.length === 0) {
                setProgress(0);
                return;
            }
            const calculatedProgress = (translatedData.length / data.length) * 100;
            setProgress(calculatedProgress);
        };

        if (data.length > 0) {
            calculateProgress();
        }

    }, [data, translatedData]);
    useEffect(() => {
        loadlanguages();
    }, []);
    const getDataForTranslation = async (countryId) => {
        try {
            setActiveCountryId(countryId);
            const req = await sendAPIRequest(`/api/translate/raw-text?country_id=${countryId}&contentType=${selectedContentType}&lang_id=${selectedLanguage.value}`);
            const res = await req.json();
            if (res.success) {
                setData(res.data)
            }
        } catch (e) {
            console.log(e);
        }
    }
    const getTranslatedData = async (countryId) => {
        try {
            setActiveCountryId(countryId);
            const req = await sendAPIRequest(`/api/translate/translated-data?country_id=${countryId}&lang_id=${selectedLanguage.value}&contentType=${selectedContentType}&istranslated=true`);
            const res = await req.json();
            if (res.success) {
                settranslatedData(res.data)
            }
        } catch (e) {
            console.log(e);
        }
    }
    const onLoad = async () => {
        if (selectedLanguage.value && selectedContentType) {
            await loadCountries()
            setData([])
            settranslatedData([])
            setActiveCountryId(null)
        }
        else {
            displayNotification("info", `${t("-1", "Please Select Both fields")}`);
        }
    }
    const loadCountries = async () => {
        try {
            const req = await sendAPIRequest(`/api/country?lang_id=${selectedLanguage.value}`);
            const res = await req.json();
            if (res.success) {
                setCountry(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    }
    const loadlanguages = async () => {
        try {
            const req = await sendAPIRequest(`/api/list/master/3`);
            const res = await req.json();
            if (res.success) {
                setlanguages(res.data);
            }
        } catch (e) {
            console.log(e);
        }
    }
    const translateData = async (countryId) => {
        try {
            const req = await sendAPIRequest(`/api/translate/translating?country_id=${countryId}&contentType=${selectedContentType}&lang_id=${selectedLanguage.value}`);
            const res = await req.json();

            if (res.success) {
                displayNotification("success", `${t("-1", "Successfully translated data")} [B]`);
                return true;
            } else {
                displayNotification("error", `${t("222", "Error loading data")} [B]`);
                return false;
            }
        } catch (e) {
            console.log(e);
            displayNotification("error", `${t("222", "Error loading data")} [F]`);
            return false;
        }
    };

    const trasnlateAllData = async (countryId) => {
        let dataExists = true;
        try {
            const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
            do {
                const req = await sendAPIRequest(`/api/translate/translated-data?country_id=${countryId}&lang_id=${selectedLanguage.value}&contentType=${selectedContentType}&istranslated=false`);
                const res = await req.json();

                if (res.success) {
                    if (res.data.length > 0) {
                        const translationSuccess = await translateData(countryId);
                        if (!translationSuccess) {
                            dataExists = false;
                            displayNotification("info", "Process Stopped.");
                            break;
                        }
                        await getTranslatedData(countryId)
                        await delay(5000);
                    }
                    if (res.data.length === 0) {
                        dataExists = false;
                        displayNotification("info", "All data has been translated.");

                    }
                } else {
                    displayNotification("error", `${t("222", "Error loading data")} [B]`);
                    displayNotification("info", `${t("222", "data can't be translated")} [B]`);
                    dataExists = false;
                }
            } while (dataExists);
            if (!dataExists) {
                displayNotification("info", "Translation process stopped.");
            }
        } catch (e) {
            console.log(e);
            displayNotification("error", `${t("222", "Error loading data")} [F]`);
        }
    };
    const languageOptions = useMemo(() => {
        return generateOptionsFromData(languages, {
            value: "id",
            label: "list_element_name",
        });
    }, [languages]);
    return (
        <>
            <div className="header card-woah border border-secondary px-4 py-2 shadow-sm w-100 my-2">
                <div className="card-title-1 lh-1">{t("-1", "Translate Data")}</div>
            </div>
            <div className="header card-woah border border-secondary px-4 py-2 shadow-sm w-100 my-2">
                <div className="card-body p-4">
                    <div className="row me-3">
                        <div className="col-5 mb-2">
                            <Tooltip
                                title={t("-1", "Select an option")}
                                placement="top"
                                arrow
                            >
                                <div className="mb-4">
                                    <AutoCompleteDropdown
                                        label={t("-1", "Language")}
                                        showClearIcon={false}
                                        error={false}
                                        required={false}
                                        multiple={false}
                                        hasselectall={false}
                                        options={languageOptions}
                                        onChange={(event, value) => {
                                            setSelectedLanguage({ label: value.label, value: value.value });
                                        }}
                                        value={
                                            selectedLanguage.value ?
                                                languageOptions.find(
                                                    (r) => r.value == selectedLanguage.value
                                                ) : null
                                        }
                                    />
                                </div>
                            </Tooltip>
                        </div>

                        <div className="col-5 mb-2">
                            <Tooltip
                                title={t("-1", "Select an option")}
                                placement="top"
                                arrow
                            >
                                <div className="mb-4">
                                    <AutoCompleteDropdown
                                        label={t("-1", "Content Type")}
                                        showClearIcon={false}
                                        error={false}
                                        required={false}
                                        multiple={false}
                                        hasselectall={false}
                                        options={ContentTypeOptions}
                                        onChange={(event, value) => {
                                            setSelectedContentType(value.value)
                                        }}
                                        value={
                                            selectedContentType ?
                                                ContentTypeOptions.find(
                                                    (r) => r.value == selectedContentType
                                                ) : null
                                        }
                                    />
                                </div>
                            </Tooltip>
                        </div>

                        <div className="col-2 mb-2">
                            <button
                                className="btn btn--primary fs-7"
                                type="button"
                                onClick={onLoad}
                            >
                                <span className="align-middle">{t("-1", "Load")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="header card-woah border border-secondary px-4 py-2 shadow-sm w-100 my-2">
                <div className="card-body p-4">
                    <div className="row ">
                        <div className="col-4 border border-secondary" >
                            <div className="fw-bold fs-5 py-3 shadow-sm mb-2 text-center">
                                <strong>Country ({country ? country.length : 0})</strong>
                            </div>
                            <div style={{ maxHeight: '750px', overflowY: 'auto' }}>
                                {
                                    country && country.map((item, index) => (
                                        <div className="row mb-2 p-1" key={index}>
                                            <div
                                                className={`fw-bold fs-6 cursor-pointer 
                                                        ${activeCountryId === item.id ? 'text-white bg-primary-light' : 'text-primary'} 
                                                        ${data.length !== translatedData.length ? 'col-8 ' : 'col-12'}`}

                                                onClick={() => {
                                                    getDataForTranslation(item.id);
                                                    getTranslatedData(item.id);
                                                }}
                                            >
                                                {item.country_complete_name}</div>
                                            {activeCountryId === item.id && data.length !== translatedData.length && (
                                                <div
                                                    // className="col-4"
                                                    className={`${activeCountryId === item.id && data.length !== translatedData.length ? 'col-4' : 'd-none'}`}

                                                >
                                                    <span
                                                        className="ms-2 badge badge-secondary cursor-pointer"
                                                        onClick={() => trasnlateAllData(item.id)}
                                                    >
                                                        Translate
                                                    </span>
                                                </div>
                                            )}


                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        <div className="col-4 border border-secondary">
                            <div className="fw-bold fs-5 py-3 shadow-sm mb-2 text-center">
                                <strong>Report ({data ? data.length : 0})</strong>
                            </div>
                            <div className="p-1" style={{ maxHeight: '750px', overflowY: 'auto' }}>
                                {
                                    data && data.length > 0 ? (
                                        data.map((item, index) => (
                                            <div className="mb-2 border border-secondary justify-content-center" key={index}>
                                                {item.heading_text ? item.heading_text : item.concept_name ? item.concept_name : item.umb_concept}
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-center">
                                            {/* No data found */}
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        <div className="col-4 border border-secondary">
                            <div className="fw-bold fs-5 py-3 shadow-sm mb-2 text-center">
                                <strong>Translated Report ({translatedData ? translatedData.length : 0})</strong>
                            </div>
                            {
                                data.length > 0 &&
                                <Box className="bg-secondary rounded" sx={{ marginBottom: `5px`, paddingY: `8px` }}>
                                    <Typography className="fw-bold ms-3" variant="h6" gutterBottom>
                                        Progress: {Math.min(progress.toFixed(2), 100)}% ({translatedData.length} records translated / {data.length} )
                                    </Typography>
                                    <Box sx={{ paddingX: '10px' }}>
                                        <LinearProgress
                                            variant="determinate"
                                            value={Math.min(progress, 100)}
                                            sx={{
                                                backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                                '& .MuiLinearProgress-bar': {
                                                    backgroundColor: '#ff4815',
                                                },
                                            }}
                                        />
                                    </Box>
                                </Box>
                            }


                            <div className="p-1" style={{ maxHeight: '750px', overflowY: 'auto' }}>
                                {
                                    translatedData && translatedData.length > 0 ? (
                                        translatedData.map((item, index) => (
                                            <div className="mb-2 border border-secondary justify-content-center" key={index}>
                                                {item.heading_text_en || item.concept_name_en || item.umb_concept_en}
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-center">
                                            {/* No data found */}
                                        </div>
                                    )
                                }
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};



export default Index;
